import React from 'react';
import { Box } from '@mui/material';

import { useStyles } from './styles';

const ApplicationHeader = ({ headerTitle, headerRightComponent }) => {
    const classes = useStyles();
    return (
        <Box className={classes.headerWrapper}>
            <Box>{headerTitle}</Box>
            <Box className={classes.rightWrapper}>{headerRightComponent}</Box>
        </Box>
    );
};

export default ApplicationHeader;
